import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MapContainerComponent } from "@app/address/components/map-container/map-container.component";
import { Address } from "@app/address/model/address";
import { EntityInfoTypes } from "@app/entity/model/entityinfo";
import { EntityInfoService } from "@app/entity/services/entityinfo.service";
import { environment } from "environments/environment";
import { BehaviorSubject, Observable, Subject, switchMap, take, takeUntil } from "rxjs";

@Component({
    selector: "app-system-address-step",
    templateUrl: "./system-address-step.component.html",
    styleUrls: ["./system-address-step.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemAddressStepComponent implements OnInit, OnChanges, OnDestroy {
    @Input() address$: BehaviorSubject<Address>;
    @Input() entityId: number;
    @Input() preservedAddress: Address;
    @Input() isReadOnly = false;
    @Input() addressFoundFromGoogle$ = new BehaviorSubject(false);

    readonly API_KEY = environment.firebaseConfig.apiKey;
    communities$: Observable<any[] | Error>;
    builders$: Observable<any[] | Error>;
    buildingTypes$: Observable<any[] | Error>;
    addressFound$ = new BehaviorSubject(false);

    private readonly entityIdSubject = new BehaviorSubject<number>(null);
    private readonly unsubscribe$ = new Subject();

    constructor(private readonly entityInfoService: EntityInfoService, private readonly dialog: MatDialog) {}

    ngOnInit(): void {
        this.setEntityInfoObservables();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.entityId?.currentValue) {
            this.entityInfoService.clearEntityInfoState();
            this.entityIdSubject.next(Number(changes.entityId.currentValue));
        }
    }

    ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    options: any = {
        componentRestrictions: { country: [] },
    };

    getEncodedAddressString() {
        return `${this.address$.value.coordinates?.replace(/\s+/g, "")}`;
    }

    private setEntityInfoObservables() {
        this.builders$ = this.entityIdSubject.pipe(
            takeUntil(this.unsubscribe$),
            switchMap(id => this.entityInfoService.selectEntityInfoListByType(id, EntityInfoTypes.HomeBuilders).pipe(take(1)))
        );

        this.communities$ = this.entityIdSubject.pipe(
            takeUntil(this.unsubscribe$),
            switchMap(id => this.entityInfoService.selectEntityInfoListByType(id, EntityInfoTypes.HomeCommunities).pipe(take(1)))
        );

        this.buildingTypes$ = this.entityIdSubject.pipe(
            takeUntil(this.unsubscribe$),
            switchMap(id => this.entityInfoService.selectEntityInfoListByType(id, EntityInfoTypes.BuildingType).pipe(take(1)))
        );
    }

    openMap(): void {
        const dialogRef = this.dialog.open(MapContainerComponent, { panelClass: "google-map-dialog" });
        dialogRef.componentInstance.address = this.address$.value;
    }
}
